export default __webpack_public_path__ + "static/media/cosyfish-map.81ec5018.webp";